import { k, t } from "./i18n/i18n";

/** Libellés affichés des missions dont le nom interne (repris de l'iPad) est un code ou mal accentué. La valeur
 *  enregistrée dans le dossier ne change pas. */
const LABELS: Record<string, string> = {
  Ctrz: "Contrôler une zone",
  Eclairer: "Éclairer",
  "Contre-rebellion": "Contre-rébellion",
  "Contre-Attaquer": "Contre-attaquer",
  "Effectuer un Raid": "Effectuer un raid",
};

export function missionLabel(name: string | null | undefined): string {
  if (!name) return "";
  return LABELS[name] ?? name;
}

/** Niveau de l'ordre d'un dossier, tel que l'affichent les Données initiales (« Régiment », « Brigade »…), dans
 *  la langue de l'interface. */
const LEVEL_LABELS: Record<string, string> = {
  COMPAGNIE: k("Compagnie / Escadron"),
  REGIMENT: k("Régiment"),
  BRIGADE: k("Brigade"),
  DIVISION: k("Division"),
  CORPS: k("Corps d'armée"),
  CENTAC: k("CENTAC"),
};

/** Niveau d'un dossier de compagnie selon l'arme de son S/GTIA (`level_label`, `unit_label` du serveur, docs/21). */
const COMPANY_LABELS: Record<string, string> = { Compagnie: k("Compagnie"), Escadron: k("Escadron") };

/** `unitLabel` : « Compagnie » ou « Escadron » rendu par le serveur pour un dossier de compagnie. */
export function levelLabel(level: string | null | undefined, unitLabel?: string | null): string {
  if (!level) return "";
  if (level === "COMPAGNIE" && unitLabel && COMPANY_LABELS[unitLabel]) return t(COMPANY_LABELS[unitLabel]);
  return LEVEL_LABELS[level] ? t(LEVEL_LABELS[level]) : level;
}

/** Spécialité affichée d'une unité : « Infanterie de montagne » (l'ODB de l'iPad écrit « de Montagne »), dans la
 *  langue de l'interface. */
export function specialtyLabel(specialty: string | null | undefined): string {
  if (!specialty) return "";
  return t(specialty.replace(/ de Montagne\b/g, " de montagne"));
}
